/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable require-atomic-updates */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/typedef */
import compose from 'koa-compose';
import combineParamsMiddleware from './middleware/combineParams';
import optionsParserMiddleware from './middleware/optionsParser';
export default class Http {
    constructor(parent, fetch) {
        this.get = this.wrap('GET');
        this.put = this.wrap('PUT');
        this.post = this.wrap('POST');
        this.patch = this.wrap('PATCH');
        this.delete = this.wrap('DELETE');
        this._middleware = [];
        if (parent instanceof Http) {
            this.parent = parent;
        }
        else if (fetch === undefined && typeof parent === 'function') {
            this.fetch = parent;
        }
        if (fetch) {
            this.fetch = fetch;
        }
    }
    get middleware() {
        if (this.parent) {
            return [...this.parent.middleware, ...this._middleware];
        }
        else {
            return [...this._middleware];
        }
    }
    useMiddleware(callback) {
        this._middleware.push(callback);
    }
    child(fetch) {
        return new Http(this, fetch || this.fetch);
    }
    async request(url, options) {
        if (typeof url === 'string') {
            if (options) {
                options.url = url;
            }
            else {
                options = { url };
            }
        }
        else {
            options = url;
        }
        url = options.url || '';
        options.headers = options.headers || {};
        const m = [
            ...this.middleware,
            optionsParserMiddleware,
            combineParamsMiddleware,
            async (ctx, next) => {
                const { req } = ctx;
                const res = await (this.fetch || fetch)(ctx.url, req);
                ctx.res = res;
                return await next();
            },
        ];
        const middlewareFn = compose(m);
        const ctx = {
            url,
            req: options,
            res: {},
        };
        const result = await middlewareFn(ctx);
        return result === undefined ? ctx.res : result;
    }
    wrap(method) {
        return (url, options = {}) => {
            if (typeof url === 'string') {
                options.url = url;
            }
            else {
                options = url;
            }
            options.method = method;
            return this.request(options);
        };
    }
}
//# sourceMappingURL=Http.js.map